import { moveToFulfilled, moveToPending, moveToRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { LeaderAudiencesLoadAction } from '../../domains/leadersManagement/loadLeaderAudiencesActions.types';

import { LeaderAudiences } from './types';

export type LeaderAudiencesActions = LeaderAudiencesLoadAction;

const initialState: LeaderAudiences = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<LeaderAudiences, LeaderAudiencesActions> = (state = initialState, action) => {
  switch (action.type) {
    case 'LEADER_AUDIENCES.LOAD_PENDING':
      return moveToPending(state, [action.payload.userId]);
    case 'LEADER_AUDIENCES.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.userId], action.payload.error);
    case 'LEADER_AUDIENCES.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.leaderAudiences);
    default:
      return state;
  }
};

export default reducer;
